<template>
<div class="chapter">
<div class="inner_page">
<p class="imgcenter"><img alt="image" id="img9-1" src="images/img9-1.jpg"/></p>
<p class="caption">In cold, wet conditions on campaign. 3USa</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01g-a_AMERICAN_EXPEDITIONARY_FORCE.vue?5c282d1c